import { Order } from '../../../gql/graphql'
import { AddressUpdate } from './types'

type DirtyFieldsType<T> =
  | {
      [P in keyof T]?: T[P] extends object ? DirtyFieldsType<T[P]> : boolean
    }
  | boolean

export const dirtyValues = <T>(dirtyFields: DirtyFieldsType<T>, allValues: T): T | null => {
  if (dirtyFields === true || Array.isArray(dirtyFields)) {
    return allValues
  } else if (typeof dirtyFields === 'object') {
    return Object.fromEntries(
      (Object.keys(dirtyFields) as Array<keyof T>)
        .map(key => {
          const dirtyField = dirtyFields[key]
          if (dirtyField === undefined) {
            return [key, null]
          }
          return [key, dirtyValues(dirtyField as DirtyFieldsType<T[typeof key]>, allValues[key])]
        })
        .filter(([, value]) => value !== null || (Array.isArray(value) && value.length <= 0)),
    ) as T
  } else {
    return null
  }
}
